module.exports = __webpack_public_path__ + "img/coding.05a88974.svg";